const CellTDShowroom: React.FC<{ data: any }> = ({ data }) => {

    return (
        <><small>From: {data['from_showroom']}</small><br /><small>To: {data['to_showroom']}</small></>
    )
}

export default CellTDShowroom;